module.exports = __webpack_public_path__ + "static/media/70s.64eb52d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/trends/70s.png
// module id = 332
// module chunks = 0